import { jsx as o } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { P as n } from "./Pill-uAcQLotY.js";
const c = {
  rdv_pris: "accent",
  rdv_passe: "purple",
  client_pot: "success",
  client: "success",
  a_relancer: "warning",
  perdu: "neutral"
}, p = i(
  function({ status: t, variant: r = "soft", size: s = "sm", children: a, ...e }, l) {
    return /* @__PURE__ */ o(
      n,
      {
        ref: l,
        tone: c[t],
        variant: r,
        size: s,
        "data-status": t,
        ...e,
        children: a
      }
    );
  }
);
p.displayName = "LeadStatusPill";
export {
  p as L
};
//# sourceMappingURL=LeadStatusPill-DaWOFt-a.js.map
